import groq from "groq"

import { getEmployeeReference } from "@/graphql/schemas/shared/utils/getEmployeeReference"
import { createAttachmentReferences } from "@/graphql/schemas/visit-report/utils/visitReportHelpers"
import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getVisitReportSchema } from "../utils/visitReportValidation"

export const mutationCreateVisitReport = {
  async createVisitReport(parent, args, context, info) {
    const { lang = AppSettings.defaultLocale(), cdn = true, values } = args
    const todaysDate = new Date().toISOString()

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.VISIT_REPORTS,
      operation: Operations.CREATE,
    })

    try {
      await getVisitReportSchema().validate(values)
    } catch (error) {
      throw new Error(error.message)
    }

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const employee = await getEmployeeReference({
      employeeNumber: user.employeeNumber,
      sanityClient: client,
    })
    const selectedOccasionIds = values?.occasions.map((occasion) => occasion.id)

    const occasions = await client.fetch(groq`*[_type=="occasion" && _id in $selectedOccasionIds]`, {
      selectedOccasionIds,
    })

    const updatedOccasions = occasions.map((occasion) => {
      return { _type: "reference", _ref: occasion._id, _key: occasion._id, _weak: true }
    })

    // const enrichedAttachments = values.attachments
    //   ? values.attachments.map((attachment) => {
    //       const id = uuidv4()
    //       return { ...attachment, _key: id }
    //     })
    //   : []

    const attachmentReferences = await createAttachmentReferences(values.attachmentReferences, client)

    const doc = {
      ...values,
      _type: "visitReport",
      occasions: updatedOccasions,
      creationAt: todaysDate,
      // attachments: enrichedAttachments,
      attachmentReferences: attachmentReferences || [],
      modificationSource: "Sanity",
      ...(employee && { creationBy: employee, modifiedBy: employee }),
    }

    try {
      const insertReport = await client.create(doc)

      if (!insertReport) return null

      if (insertReport) {
        return {
          ...insertReport,
          id: insertReport._id,
          rev: insertReport._rev,
        }
      }
    } catch (error) {
      throw new Error(error.message)
    }

    return null
  },
}
